import { render, staticRenderFns } from "./newtoken.vue?vue&type=template&id=0857bcbe&"
import script from "./newtoken.vue?vue&type=script&lang=js&"
export * from "./newtoken.vue?vue&type=script&lang=js&"
import style0 from "./newtoken.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports